/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Full_Stack_Web_Apps_Scope_Detail5Inputs */

const en_svc_full_stack_web_apps_scope_detail5 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data model, user flows, and MVP boundaries locked before code.`)
};

const ar_svc_full_stack_web_apps_scope_detail5 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نموذج البيانات وتدفقات المستخدم وحدود MVP مقفلة قبل الكود.`)
};

const bn_svc_full_stack_web_apps_scope_detail5 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কোডের আগে ডেটা মডেল, ইউজার ফ্লো ও MVP বাউন্ডারি লক করুন।`)
};

const de_svc_full_stack_web_apps_scope_detail5 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenmodell, Nutzerflüsse und MVP-Grenzen vor dem Code festgezurren.`)
};

const es_svc_full_stack_web_apps_scope_detail5 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modelo de datos, flujos de usuarios y límites de MVP fijados antes del código.`)
};

const fr_svc_full_stack_web_apps_scope_detail5 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modèle de données, flux d'utilisateurs et limites MVP verrouillées avant le code.`)
};

const pt_svc_full_stack_web_apps_scope_detail5 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modelo de dados, fluxos de usuário e limites de MVP fechados antes do código.`)
};

const zh_svc_full_stack_web_apps_scope_detail5 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在代码之前锁定数据模型、用户流和 MVP 边界。`)
};

const tr_svc_full_stack_web_apps_scope_detail5 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veri modeli, kullanıcı akışları ve MVP sınırları koddan önce kilitlenir.`)
};

const ru_svc_full_stack_web_apps_scope_detail5 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Модель данных, пользовательские потоки и границы MVP фиксируются до кода.`)
};

const pl_svc_full_stack_web_apps_scope_detail5 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model danych, flow userów i granice MVP zamrożone przed kodem.`)
};

/**
* | output |
* | --- |
* | "Data model, user flows, and MVP boundaries locked before code." |
*
* @param {Svc_Full_Stack_Web_Apps_Scope_Detail5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_full_stack_web_apps_scope_detail5 = /** @type {((inputs?: Svc_Full_Stack_Web_Apps_Scope_Detail5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Full_Stack_Web_Apps_Scope_Detail5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_full_stack_web_apps_scope_detail5(inputs)
	if (locale === "bn") return bn_svc_full_stack_web_apps_scope_detail5(inputs)
	if (locale === "de") return de_svc_full_stack_web_apps_scope_detail5(inputs)
	if (locale === "es") return es_svc_full_stack_web_apps_scope_detail5(inputs)
	if (locale === "fr") return fr_svc_full_stack_web_apps_scope_detail5(inputs)
	if (locale === "pt") return pt_svc_full_stack_web_apps_scope_detail5(inputs)
	if (locale === "zh") return zh_svc_full_stack_web_apps_scope_detail5(inputs)
	if (locale === "tr") return tr_svc_full_stack_web_apps_scope_detail5(inputs)
	if (locale === "ru") return ru_svc_full_stack_web_apps_scope_detail5(inputs)
	if (locale === "pl") return pl_svc_full_stack_web_apps_scope_detail5(inputs)
	return en_svc_full_stack_web_apps_scope_detail5(inputs)
});
export { svc_full_stack_web_apps_scope_detail5 as "svc_full-stack-web-apps_SCOPE_detail" }